<template>
	<div class="center">
		<h1 class="sz-6 light text-center">
			<a v-if="backButton" class="align--no-descenders" @click="$router.go(-1)">
				<inline svg="chevron-left" class="sz-3 hitchcock" />
			</a>
			{{ title }}
		</h1>
	</div>
</template>

<script>
	export default {
		name: 'AuthPageHeaderHeader',
		props: {
			title: { type: String, default: '' },
			backButton: { type: Boolean, default: false }
		}
	};
</script>